import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header/header";
import Footer from "../Footer/footer";
import './goodbye.css';

const Goodbye = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div>
      <Header />

      <div className="w-full pt-44 pb-20">
        {/* Page Heading */}
        <div className="goodbye-heading w-full md:w-4/5 mx-auto text-center mb-12 font-medium">
          <h1 className="xl:text-5xl md:text-4xl text-3xl font-ClashGrotesk text-[var(--medium-purple)]">
            Account Deleted Successfully
          </h1>
        </div>

        {/* Goodbye Message */}
        <div className="goodbye-description flex flex-col md:w-4/5 w-[90%] text-center mx-auto font-manrope md:text-lg text-base bg-[--white] p-8 md:p-12 rounded-2xl text-[var(--dark-blue)] font-semibold mb-10 gap-6">
          <div className="flex justify-center mb-4">
            <svg 
              className="w-20 h-20 text-green-500" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" 
              />
            </svg>
          </div>

          <h2 className="text-2xl md:text-3xl font-ClashGrotesk text-[var(--medium-purple)]">
            We're sorry to see you go!
          </h2>
          
          <p className="text-base md:text-lg">
            Your account has been successfully deleted from the Net Gala platform. 
            All your personal information has been removed from our active database.
          </p>

          <p className="text-base md:text-lg">
            We hope you enjoyed your time with us. If you ever change your mind, 
            you're always welcome to create a new account and rejoin our community.
          </p>

          <p className="text-base md:text-lg">
            Thank you for being a part of Net Gala. We wish you all the best!
          </p>

          <div className="flex justify-center mt-6">
            <button
              onClick={handleGoHome}
              className="bg-[var(--button-green)] hover:opacity-90 text-[var(--dark-blue)] font-manrope font-bold py-3 px-10 rounded-lg transition-all duration-200 text-base md:text-lg"
            >
              Go to Homepage
            </button>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-300">
            <p className="text-sm md:text-base text-gray-600">
              If you have any questions or concerns, feel free to contact us at{" "}
              <a 
                className="text-[var(--reddish-brown)] hover:text-[var(--dark-blue)]" 
                href="mailto:hello@thenetgala.in"
              >
                hello@thenetgala.in
              </a>
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Goodbye;
